import * as z from "zod";
import { MAIN_BRANCH_NAME, branchNameError } from "../branchName";
import { zql } from "../generatedDrizzleSchema";
import { nameCollides } from "../nameCollides";
import { userFacingError } from "../userFacingError";
import { mutator } from "./mutator";

export const renameBranch = mutator({
  schema: z.object({ branchId: z.string(), name: z.string() }),
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { branch, name } }) => {
    if (branch.name === MAIN_BRANCH_NAME)
      throw userFacingError("The main branch can’t be renamed.");

    const trimmed = name.trim();
    const error = branchNameError(trimmed);
    if (error) throw userFacingError(error);

    const siblings = await tx.run(
      zql.workflowBranches.where("workflowId", branch.workflowId)
    );
    if (nameCollides(trimmed, siblings, branch.id))
      throw userFacingError(
        `A branch named “${trimmed}” already exists in this workflow.`
      );

    await tx.mutate.workflowBranches.update({ id: branch.id, name: trimmed });
  },
});
